<template>
  <div class="funding-terms">
    <p>
      <b>
        <u>
          PLEASE READ THESE TERMS CAREFULLY BEFORE MAKING A DONATION. THE TERMS
          APPLY TO ANY PERSON THAT MAKES A DONATION (“YOU”, “YOUR”). BY MAKING A
          DONATION, YOU CONFIRM THAT YOU HAVE READ AND UNDERSTOOD THE TERMS AND
          AGREE TO BE BOUND BY THEM.
        </u>
      </b>
    </p>

    <HideableParagraph title="1. Introduction " text=" ">
      <div class="legal-text">
        <p>
          1.1 Custom Content Technology Ltd (“CCT”, “we”, “us”, or “our”)
          operates https://found.us/ (“Website”) through which individuals, such
          as yourself (“Contributors”), can make financial contributions
          (“Contributions”) to a specific Creator to support the production
          and/or publishing of their Book.
        </p>
        <p>
          1.2 These terms and conditions (“Terms”) govern your Contributions
          made via the Website and form a legally binding agreement between you
          and CCT. We may update these Terms from time to time. Every time you
          wish to use the Website, please check these Terms to ensure you
          understand the terms that apply at that time.
        </p>
        <p>
          1.3 Your use of the Website is also subject to the general website
          terms found here: <a href="/terms">Terms of use | Found</a> (“Website
          and Supply Terms”). These Terms must be read in conjunction with the
          Website and Supply Terms. If there is any contradiction between these
          Terms and the Website and Supply Terms in relation to your
          Contributions, these Terms shall take precedence.
        </p>
      </div>
    </HideableParagraph>

    <HideableParagraph title="2. Definitions" text=" ">
      <div class="legal-text">
        <p>
          2.1 <strong>Book:</strong> the book (in hard copy and/or digital copy,
          as applicable) that CCT shall endeavour to print and publish if the
          Target of the applicable Creator Fundraiser is reached.
        </p>
        <p>
          2.2 <strong>Creator</strong>: any creator who has a Contribution Page.
        </p>
        <p>
          2.3 <strong>Creator Fundraiser</strong>: a campaign initiated on the
          Contribution Page with the goal of raising funds which will finance
          the production and/or publishing of that Creator’s Book.
        </p>
        <p>
          2.4 <strong>Contribution Page</strong>: a page set up for a specific
          Creator on the Website for the purpose of collecting Contributions to
          support the production and/or publishing of their Book
        </p>
        <p>
          2.5 <strong>Fundraising Deadline</strong>: the deadline for which a
          Target for a Creator Fundraiser must be reached (as may be amended by
          CCT from time to time).
        </p>
        <p>
          2.6 <strong>Maximum Contribution Amount</strong>: the maximum amount
          that can be donated towards a Creator Fundraiser without being
          eligible to receive a Book. Such amount shall be set out on the
          applicable Contribution Page.
        </p>
        <p>
          2.7 <strong>Target</strong>: the financial target for each Creator
          Fundraiser as set out in the applicable Contribution Page (as may be
          amended by CCT from time to time).
        </p>
      </div>
    </HideableParagraph>

    <HideableParagraph title="3. CCT’s Role" text=" ">
      <div class="legal-text">
        <p>
          3.1 CCT launches Creator Fundraisers to raise funds for the production
          and/or publication of Books. CCT is not a bank, payment processor,
          broker, charity or financial advisor. CCT does not solicit donations,
          the existence of the Creator Fundraiser is not a solicitation of
          donations, and we do not engage in solicitation activities for
          ourselves or others.
        </p>
        <p>
          3.2 The Creator Fundraisers are not, nor are they intended to be,
          loan-based crowdfunding or investment- based crowdfunding. The Creator
          Fundraisers are not regulated activities under the Financial Services
          and Markets Act 2000.
        </p>
      </div>
    </HideableParagraph>

    <HideableParagraph title="4. Eligibility Requirements" text=" ">
      <div class="legal-text">
        <p>
          4.1 If you are under 18, you are prohibited from making a
          Contribution. By making a Contribution, you represent and warrant that
          you are over the age of 18.
        </p>
        <p>
          4.2 If the Contribution Page specifies any other eligibility
          requirements, these must also be met before making a Contribution. By
          making a Contribution, you represent and warrant that you meet these
          requirements.
        </p>
        <p>
          4.3 You may make a Contribution no matter your location, but it is
          your responsibility to check that making a Contribution will not put
          you in breach of applicable laws or regulations.
        </p>
      </div>
    </HideableParagraph>

    <HideableParagraph title="5. Making a Contribution" text=" ">
      <div class="legal-text">
        <p>
          5.1 You may make a Contribution by following the on-screen prompts on
          the applicable Contribution Page.
        </p>
        <p>
          5.2 When making a Contribution, you must provide information about
          yourself (including your payment information) either to us or our
          Payment Processors that is accurate, complete and up to date in all
          respects.
        </p>
        <p>
          5.3 You must make a Contribution using one of our approved payment
          methods as set out on the Website from time to time.
        </p>
        <p>
          5.4 By making a donation you warrant that you are legally authorised
          to make the Contribution using your payment method. If for any reason
          it transpires that you are (or were) not authorised to use your
          payment method or the information you have provided is inaccurate,
          false, misleading or fraudulent, we reserve the right to cancel or
          reverse the Contribution and to report you to the appropriate
          authorities.
        </p>
        <p>
          5.5 There may be a minimum amount you can donate, and once you donate,
          your money will not be refunded unless you are entitled to a refund in
          accordance with these Terms. By making a Contribution, you acknowledge
          and accept that any transactions processed are donations without the
          expectation or exchange of goods or services (save for where otherwise
          specified in the Terms).
        </p>
        <p>
          5.6 If you believe that an error has occurred with your Contribution,
          please contact us so we can attempt to resolve the issue.
        </p>
      </div>
    </HideableParagraph>

    <HideableParagraph title="6. Payment Processors" text=" ">
      <div class="legal-text">
        <p>
          6.1 CCT does not handle the actual processing of payments. Instead, we
          use third-party payment processors (“<strong
            >Payment Processors</strong
          >”) to manage and process all Contributions for Creator Fundraisers.
        </p>
        <p>
          6.2 In order to complete a Contribution, you may be required to
          register with and/or provide information to the Payment Processor.
        </p>
        <p>
          6.3 By making a Contribution, you confirm that you have read and
          understood the Payment Processors’ privacy policy and applicable terms
          and conditions. You also agree to the processing, use, transfer or
          disclosure of data by the Payment Processors set forth in these Terms
          and any applicable Payment Processors’ terms and conditions.
        </p>
        <p>
          6.4 Our current Payment Processors include: Stripe Technology Company
          Limited – please click <a href="/terms">here</a> for Privacy Policy
          and Terms and Conditions.
        </p>
      </div>
    </HideableParagraph>

    <HideableParagraph
      title="7. Contributor Responsibilities and Obligations "
      text=" "
    >
      <div class="legal-text">
        <p>
          7.1 When you make a Contribution on the Platform, it is your
          responsibility to understand how your Contribution will be used, and
          you donate at your own risk. It is up to you to decide if a cause is
          worth contributing to.
        </p>
        <p>
          7.2 CCT provides no guarantee that any Creator Fundraiser will achieve
          its Target by the Fundraising Deadline or that the Book will be
          published (even where the Target is met). CCT reserves the right to
          amend the Target or the Fundraising Deadline from time to time. CCT
          may also at any time suspend, place on hold or terminate a Creator
          Fundraiser. It is therefore your responsibility to make sure to
          regularly check the Contribution Page for any updates or new
          information.
        </p>
        <p>
          7.3 Unless you choose to donate anonymously, you consent to CCT using
          or sharing your name or contact information to encourage others to
          donate, provided however CCT will obtain any additional consents
          required under the applicable data protection laws.
        </p>
        <p>
          7.4 We take any reports of fraud or misuse of funds very seriously. If
          you have reason to believe that a Creator is promoting their Creator
          Fundraiser in a way that is not reflective of the actual purpose of
          the Creator Fundraiser, please contact:
          <a href="mailto:louise@found.us">louise@found.us</a>
        </p>
      </div>
    </HideableParagraph>

    <HideableParagraph title="8. Supply of Books" text=" ">
      <div class="legal-text">
        <p>
          8.1 A Creator Fundraiser may from time to time offer Contributors the
          right to pre-order Books (which may or may not include inscriptions)
          in return for their Contribution.
        </p>
        <p>8.2 The supply of all Books is strictly conditional upon:</p>
        <p>8.2.1 The relevant Creator Fundraiser meeting its Target;</p>
        <p>8.2.2 The Book being completed and published; and</p>
        <p>
          8.2.3 CCT being able to lawfully supply the Book in your jurisdiction.
        </p>
        <p>
          8.3 Provided that the conditions in clause 8.2 have been met, we shall
          notify you by e-mail (using the e-mail address provided).
        </p>
        <p>
          8.4 Once the conditions in clause 8.2 have been met, and we have
          notified you by email pursuant to clause 8.3, a contract for the
          supply of the pre-ordered Book shall form between you and CCT (each a
          “Contract”).
        </p>
        <p>
          8.5 Each Contract shall be subject to our standard terms of supply set
          out here:
          <a href="https://found.us/terms">https://found.us/terms</a> (as may be
          updated by use from time to time) and the provisions in clauses 8, 9
          and 10 of the Terms shall also apply to the supply of the Book.
        </p>
        <p>
          8.6 If you reside in the UK, USA, Canada, the EU or Latin America, you
          shall receive a physical copy of the Book to the delivery address
          specified when making the Contribution. You are responsible for
          providing accurate delivery details and for any customs duties, import
          taxes, or local delivery restrictions that may apply. Please see
          clause 9.1 for the applicable cancellation rights.
        </p>
        <p>
          8.7 If you reside outside these jurisdictions, you shall receive
          digital copies of the Book to the email address provided when making
          the Contribution which will be delivered electronically, using the
          contact details provided by the Contributor. Please see clause 9.2 for
          the applicable cancellation rights.
        </p>
        <p>
          8.8 We make no warranties, guarantees or promises with respect to the
          Books or their supply beyond those required by law.
        </p>
      </div>
    </HideableParagraph>

    <HideableParagraph title="9. Returns" text=" ">
      <div class="legal-text">
        <p>
          9.1 Your cancellation rights in relation to physical copies of the
          Book:
        </p>
        <p>
          9.1.1 You have a legal right to cancel the supply of a physical Book
          and receive a refund, including the delivery costs.
        </p>
        <p>
          9.1.2 To exercise your right to cancel, you must notify us within 14
          days of delivery by contacting us at
          <a href="mailto:hello@found.us">hello@found.us</a>
        </p>
        <p>
          9.1.3 Subject to the provisions of this clause, if you exercise your
          cancellation right, you are entitled to a refund equal to the
          difference between your Contribution and the Maximum Contribution
          Amount, plus delivery costs if applicable.
        </p>
        <p>
          <i
            >Example: the Contribution for a Creator Fundraiser is £30. The
            Maximum Contribution Amount is £20. If you exercise your right to
            change your mind, you are entitled to receive a refund of £10.
          </i>
        </p>
        <p>
          9.1.4 This cancellation right does not apply to a Book that has been
          clearly personalised (this includes where the Books is inscribed).
        </p>
        <p>
          9.1.5 You must return the Book in order to be eligible for a refund.
          Returns are at your own cost and you must send the Book back to us
          using an established delivery service. For help with returns, please
          contact us at <a href="mailto:hello@found.us">hello@found.us</a>
        </p>
        <p>
          9.1.6 If we don’t receive the Book at all or within 14 days from your
          notification under clause Error: Reference source not found, and you
          are unable to provide proof of postage, we will not issue a refund.
        </p>
        <p>
          9.1.7 If the Book is returned in a condition which would not be
          acceptable in-store, we reserve the right to reduce your refund to
          reflect the reduced value.
        </p>
        <p>
          9.1.8 We refund standard delivery costs only – additional charges like
          express delivery or a selected time slot are not refundable.
        </p>
        <p>
          9.2 If you have not received email confirmation that your return has
          been processed within 14 days of returning the Book, or for any other
          help with returns, contact us at
          <a href="mailto:hello@found.us">hello@found.us</a>
        </p>
        <p>9.3 Your cancellation rights in relation to digital Books:</p>
        <p>
          9.3.1 When you make a Contribution and are eligible to receive a
          digital Book, you acknowledge that you will immediately lose your
          right to cancel your order as soon as we have supplied you a digital
          copy of the Book.
        </p>
      </div>
    </HideableParagraph>

    <HideableParagraph title="10. Faulty or incorrect Book" text=" ">
      <div class="legal-text">
        <p>
          10.1 If you think there is something wrong with your Book, you must
          contact us at <a href="mailto:hello@found.us">hello@found.us</a>.
        </p>
        <p>
          10.2 We honour our legal duty to provide you with a Book that was
          described to you on our website and that meets all the applicable
          legal requirements.
        </p>
      </div>
    </HideableParagraph>

    <HideableParagraph title="11. Faulty or incorrect Book" text=" ">
      <div class="legal-text">
        <p>
          11.1 All Contributions are made at the Contributor’s own risk. By
          making a Contribution, the Contributor acknowledges and accepts that
          CCT cannot guarantee the success, completion or fulfilment of any
          Creator Fundraiser.
        </p>
        <p>
          11.2 The Contributor understands that a Creator Fundraiser may not
          reach its Target or may otherwise be delayed, or cancelled.
        </p>
        <p>
          11.3 Even where a Creator Fundraiser achieves its Target, the
          Contributor acknowledges that the relevant Book may still not be
          published.
        </p>
        <p>
          11.4 To the fullest extent permitted by law, CCT shall not be
          responsible for any loss or damages (whether direct or indirect)
          arising from delays, cancellations, or failure of a Creator Fundraiser
          to proceed to completion or for a Book to be published.
        </p>
      </div>
    </HideableParagraph>

    <HideableParagraph title="12. Contribution Refunds" text=" ">
      <div class="legal-text">
        <p>
          12.1 We may, at our sole discretion, offer or issue a refund of
          Contribution(s), in the following circumstances:
        </p>
        <p>
          12.1.1 The Creator Fundraiser does not reach its Target by the
          Fundraising Deadline;
        </p>
        <p>
          12.1.2 CCT cancels or terminates a Creator Fundraiser for regulatory,
          legal or operational purposes; and/or
        </p>
        <p>
          12.1.3 Either the Creator or CCT decide, at their sole discretion, not
          to publish the Book.
        </p>
        <p>
          12.2 When issuing a refund to you, we will be entitled to deduct or
          retain any third party fees, including banking fees, before remitting
          the balance to you. The refund will be paid to the same account used
          to make the Contribution.
        </p>
        <p>
          12.3 In the event you are issued a refund under this clause 10, you
          will no longer receive any Books associated with your Contribution.
        </p>
      </div>
    </HideableParagraph>

    <HideableParagraph title="13. Disclaimers" text=" ">
      <div class="legal-text">
        <p>
          13.1 The Contribution Page may include information and materials
          uploaded by others, including Creators. This information and these
          materials have not been verified or approved by us.
        </p>
        <p>
          13.2 Although we make reasonable efforts to update the information on
          the Contribution Page, we make no representations, warranties or
          guarantees, whether express or implied, that the content on the
          Contribution Page is accurate, complete or up to date.
        </p>
        <p>
          13.3 The content on the Contribution Page is provided for general
          information only. It is not intended to amount to advice on which you
          should rely. You must obtain professional or specialist advice before
          taking, or refraining from, any action on the basis of the content on
          our Contribution Page.
        </p>
        <p>
          13.4 We do not guarantee that the Contribution Page, or any content on
          it, will always be available or be uninterrupted. We may suspend or
          withdraw or restrict the availability of all or any part of the
          Contribution Page for business and operational reasons. We will try to
          give you reasonable notice of any suspension or withdrawal.
        </p>
        <p>
          13.5 Where the Contribution Page contains links to other sites and
          resources provided by third parties, these links are provided for your
          information only. Such links should not be interpreted as approval by
          us of those linked websites or information you may obtain from them.
          We have no control over the contents of those sites or resources.
        </p>
        <p>
          13.6 We do not guarantee that our Website will be secure or free from
          bugs or viruses. You are responsible for configuring your information
          technology, computer programs and platform to access our Website. You
          should use your own virus protection software.
        </p>
      </div>
    </HideableParagraph>

    <HideableParagraph title="14. Intellectual Property Rights" text=" ">
      <div class="legal-text">
        <p>
          We are the owner or the licensee of all intellectual property rights
          in our Website, and in the material published on it. Those works are
          protected by copyright laws and treaties around the world. All such
          rights are reserved.
        </p>
      </div>
    </HideableParagraph>

    <HideableParagraph title="15. Liability" text=" ">
      <div class="legal-text">
        <p>
          15.1 This clause covers liability of any kind, whether in contract,
          tort (including negligence), breach of statutory duty, or otherwise.
        </p>
        <p>
          15.2 We do not exclude or limit in any way our liability to you where
          it would be unlawful to do so. This includes liability for death or
          personal injury caused by our negligence or the negligence of our
          employees, agents or subcontractors and for fraud or fraudulent
          misrepresentation.
        </p>
        <p>
          15.3 We will not be liable to you for loss of profits, sales, business
          or revenue, business interruption, loss of anticipated savings, loss
          of business opportunity, goodwill or reputation, any indirectly or
          consequential loss or damage, or any special or punitive loss or
          damage.
        </p>

        <p>15.4 In no circumstances will our liability to you exceed £50.</p>

        <p>
          15.5 We exclude all implied conditions, warranties, representations or
          other terms that may apply.
        </p>
      </div>
    </HideableParagraph>

    <HideableParagraph title="16. General" text=" ">
      <div class="legal-text">
        <p>
          16.1 We shall not be liable for any delay or failure in the
          performance of our obligations for so long as and to the extent that
          delay or failure results from any event, circumstance or cause beyond
          our reasonable control.
        </p>
        <p>
          16.2 We may transfer our rights and obligations under these Terms to
          another person or organisation. We will always tell you in writing if
          this happens.
        </p>

        <p>
          16.3 We may make changes to the Contribution Page from time to time.
        </p>

        <p>
          16.4 These Terms (and any other documents referenced in it)
          constitutes the entire agreement between the parties and supersedes
          and extinguishes all previous agreements, promises, assurances and
          understandings between you and us.
        </p>

        <p>
          16.5 A waiver of any of our rights or remedies is only effective if
          given in writing and shall not be deemed a waiver or any subsequent
          right or remedy. A failure or delay by us to exercise, or the single
          or partial exercise of, any right or remedy does not waive that or any
          other right or remedy, nor does it prevent or restrict the further
          exercise of that or any other right or remedy.
        </p>
        <p>
          16.6 If any provision or part-provision of the Terms is or becomes
          invalid, illegal or unenforceable, it shall be deemed deleted but that
          shall not affect the validity and enforceability of the rest of the
          Terms and CCT shall be entitled to incorporate a replacement provision
          or part-provision which shall, from the date of notification of such
          replacement, be deemed as part of the Terms and shall take effect from
          the date these Terms took effect.
        </p>
        <p>
          16.7 We may contact you using any of the contact details provided when
          make a Contribution. All communications and/or notices shall be deemed
          to be received within 48 hours of sending the communication and/or
          notice.
        </p>
        <p>
          16.8 The Terms, and any dispute or claim (including non-contractual
          disputes or claims) arising out of or in connection with it or its
          subject matter or formation, shall be governed by and construed in
          accordance with the law of England and Wales.
        </p>
        <p>
          16.9 Each party irrevocably agrees that the courts of England and
          Wales shall have exclusive jurisdiction to settle any dispute or claim
          (including non-contractual disputes or claims) arising out of or in
          connection with the Terms or its subject matter or formation.
        </p>
      </div>
    </HideableParagraph>

    <HideableParagraph title="17. How to contact us" text=" ">
      <div class="legal-text">
        <p>
          17.1 To contact us, please email
          <a href="mailto:hello@found.us">hello@found.us</a>.
        </p>
      </div>
    </HideableParagraph>
  </div>
</template>

<script>
import HideableParagraph from '@/components/HideableParagraph';

export default {
  name: 'FundingTermsUS',
  components: {
    HideableParagraph
  }
};
</script>

<style lang="scss" scoped>
.funding-terms {
  * {
    text-align: justify;
  }
}

a {
  color: inherit;
  text-decoration: underline;
}
</style>
